const sliders = async function () {
    const   swiperImages = document.querySelectorAll('.swiper-images'),
            swiperHeadings = document.querySelectorAll('.swiper-heading'),
            swiperUpdatesPress = document.querySelectorAll('.swiper-updates-press');

    if (swiperImages || swiperHeadings) {
        let Swiper = await (await import("swiper/bundle")).default;

        if (swiperImages) {
            swiperImages.forEach(el => {
                const swiper = new Swiper(el, {
                    loop: false,
                    slidesPerView: 1,
                    speed: 600,
                    lazy: true,
                    // autoplay: {
                    //     delay: 5000,
                    //     disableOnInteraction: false,
                    // },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            return '<span><span>' + ('0' + current).slice(-2) + '</span> / <span>' + ('0' + total).slice(-2) + '</span></span>';
                        }
                    },
                    navigation: {
                        nextEl: el.querySelector('.swiper-button-next'),
                        prevEl: el.querySelector('.swiper-button-prev'),
                    },
                    renderCustom: function (swiper, current, total) {
                        return current + '/' + total;
                    }
                });
            });
        }

        if (swiperHeadings) {
            swiperHeadings.forEach(el => {
                const swiper = new Swiper(el, {
                    effect: "creative",
                    creativeEffect: {
                        prev: {
                            translate: [0, "-33.3%", 0],
                        },
                        next: {
                            translate: [0, "33.33%", 0],
                        },
                    },
                    loop: true,
                    // slidesPerView: 1,
                    // speed: 600,
                    // lazy: true,
                    // direction: "vertical",
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'bullets'
                    }
                });
            });
        }
        
        if (swiperUpdatesPress) {
            swiperUpdatesPress.forEach(el => {
                const swiper = new Swiper(el, {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 28,
                    loop: false,
                    autoHeight: true,
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'bullets'
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                        }
                    }
                });
            });
        }
    }
};
export const init = sliders;
